<template>
    <div>
        <m-assembly-table
            ref="pageForm"
            :formData='formData'
            :columns="columns"
            :data="tableData"
            :tableButtons="tableButtons"
            :loading="loading"
            :currentPage="settings.currentPage"
            :pageSize="settings.pageSize"
            :total="settings.total"
            :settings="settings"
            thDrag
            @onSubmit='onSubmit'
            @onSelectionChange="onSelection"
            @onPageSizeChange='onPageSizeChange'
            @onCurrentPageChange='onPageChange'
        >
        </m-assembly-table>
    </div>
</template>
<script>
import mAssemblyTable from '@/components/awesome/page/assembly_table/index';
import axios from 'axios';
import moment from 'moment';
import processInspectionMixin from './processInspection';

export default {
    name: 'processInspectionAdd',
    components: {
        mAssemblyTable,
    },
    mixins: [processInspectionMixin],
    data() {
        return {
            formData: {
                row: 2,
                items: [
                    {
                        value: '',
                        field: 'orgCode',
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('processInspectionSearch.t18'),
                            },
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            multiple: false,
                            values: [],
                        },
                        type: 'select',
                        title: this.$t('processInspectionSearch.t13'), // 库存组织
                        methods: {
                            change: (val) => {
                                this.selection = [];
                                this.tableData = [];
                            },
                        },
                    },
                    {
                        value: '',
                        field: 'poNumber',
                        placeholder: this.$t('createDeliveryOrderByOrder.t50'),
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('processInspectionSearch.t2'), // 采购单号
                    },
                    {
                        value: moment().subtract('6', 'M').format('YYYY-MM-DD 00:00:00'),
                        field: 'needByDateBegin',
                        // validators: {
                        //     required: {
                        //         required: true,
                        //         message: this.$t('createDeliveryOrderToInformView.t49')
                        //     },
                        // },
                        style: 'width:100%',
                        layout: {
                            row: 1,
                            span: 8,
                            offset: 0,
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 00:00:00',
                            options: {
                                disabledDate(date) {
                                    const dt = new Date();
                                    dt.setMonth(dt.getMonth() - 12);
                                    return date && date.valueOf() < dt - 86400000;
                                },
                            },
                        },
                        type: 'datePicker',
                        title: this.$t('processInspectionSearch.t8'), // 需求日期
                        placeholder: '',
                        isDouble: true,
                    },
                    {
                        hide: true,
                        value: moment().add('6', 'M').format('YYYY-MM-DD 00:00:00'),
                        field: 'needByDateEnd',
                        // validators: {
                        //     required: {
                        //         required: true,
                        //         message: this.$t('createDeliveryOrderToInformView.t49')
                        //     }
                        // },
                        layout: {
                            span: 4,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 23:59:59',
                            options: {
                                disabledDate(date) {
                                    const dt = new Date();
                                    const dt2 = new Date();
                                    dt.setMonth(dt.getMonth() - 12);
                                    dt2.setMonth(dt2.getMonth() + 12);
                                    return date && (date.valueOf() < dt || date.valueOf() > dt2);
                                },
                            },
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: '',
                    },
                    {
                        value: '',
                        field: 'itemCode',
                        placeholder: this.$t('createDeliveryOrderByOrder.t50'),
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('processInspectionSearch.t4'), // 物料编码
                    },
                ],
            },
            columns: {
                columns: [
                    {
                        type: 'selection',
                        align: 'center',
                        width: 30,
                    },
                    {
                        title: this.$t('processInspectionSearch.t2'), // 采购订单号
                        key: 'poNumber',
                        align: 'center',
                        minWidth: 100,
                    },
                    {
                        title: this.$t('processInspectionSearch.t3'), // 采购单行号
                        key: 'poLineNumber',
                        align: 'center',
                        minWidth: 60,
                    },
                    {
                        title: this.$t('processInspectionSearch.t4'), // 物料编码
                        key: 'itemCode',
                        align: 'center',
                        minWidth: 100,
                    },
                    {
                        title: this.$t('processInspectionSearch.t5'), // 物料描述
                        key: 'itemDesc',
                        minWidth: 100,
                        tooltip: true,
                    },
                    {
                        title: this.$t('processInspectionSearch.t6'), // 单位
                        key: 'itemUnit',
                        align: 'center',
                        minWidth: 60,
                    },
                    {
                        title: this.$t('processInspectionSearch.t7'), // 订单数量
                        key: 'poQuantity',
                        align: 'center',
                        minWidth: 60,
                    },
                    {
                        title: this.$t('processInspectionSearch.t74'), // 已检验数量
                        key: 'hasCheckedQuantity',
                        align: 'center',
                        minWidth: 60,
                    },
                    {
                        title: this.$t('processInspectionSearch.t89'), // 本次检验数量
                        key: 'checkQuantity',
                        minWidth: 60,
                        render: (h, params) => {
                            let { checkQuantity, checkQuantityCopy } = params.row;
                            return h('Input', {
                                props: {
                                    value: checkQuantity,
                                    size: 'small'
                                },
                                on: {
                                    'on-blur': (event) => {
                                        let val = event.target.value;
                                        const defaultVal = checkQuantityCopy;
                                        if (!Boolean(val) || !/^[1-9]\d*$/.test(val)) {
                                            this.$Modal.error({
                                                title: this.$t('common.warn'),
                                                content: this.$t('processInspectionSearch.t92'),
                                            });
                                            event.target.value = defaultVal;
                                            params.row.checkQuantity = defaultVal;
                                        } else {
                                            if (Number(val) > Number(defaultVal)) {
                                                this.$Modal.error({
                                                    title: this.$t('common.warn'),
                                                    content: `${this.$t('processInspectionSearch.t93')}${defaultVal}`,
                                                });
                                                event.target.value = defaultVal;
                                                params.row.checkQuantity = defaultVal;
                                            } else {
                                                params.row.checkQuantity = event.target.value;
                                            }
                                            this.tableData[params.index] = params.row;
                                        }
                                    },
                                },
                            });
                        },
                    },
                    {
                        title: this.$t('processInspectionSearch.t8'), // 需求日期
                        key: 'poNeedByDate',
                        align: 'center',
                        minWidth: 100,
                        render: (h, params) => {
                            const { poNeedByDate } = params.row;
                            return h('span', poNeedByDate ? moment(poNeedByDate).format('YYYY-MM-DD HH:mm:ss') : '');
                        },
                    },
                    {
                        title: this.$t('processInspectionSearch.t12'), // 采购单状态
                        key: 'poClosedCode',
                        align: 'center',
                        minWidth: 100,
                    },
                ],
            },
            tableData: [],
            tableButtons: {
                customButtons: [
                    {
                        label: this.$t('processInspectionSearch.t16'), // 维护检验报告
                        type: 'primary',
                        icon: 'archive',
                        loading: false,
                        disabled: () => this.selection.length === 0,
                        size: 'small',
                        click: () => {
                            // if (this.selection.filter((item) => !item.hasReport).length === 0) {
                            //     this.$Modal.warning({
                            //         content: this.$t('processInspectionSearch.t58'), // 请勾选未检验的数据进行维护报告
                            //     });
                            //     return false;
                            // }
                            const selection = this.$refs.pageForm.getSelection();
                            if (selection.find((item) => item.checkQuantity === 0)) {
                                this.$Modal.warning({
                                    content: this.$t('processInspectionSearch.t111'), // 本次检验数量必须大于0
                                });
                                return false;
                            }
                            const itemCode = new Set();
                            const orgCode = this.getFormDataItemVal(this.formData.items, 'orgCode');
                            selection.forEach((item) => {
                                itemCode.add(item.itemCode);
                            //     batchQty += Number(item.checkQuantity);
                            //     poLineIds.push(item.poLineId);
                            });
                            if ([...itemCode].length > 1) {
                                this.$Modal.warning({
                                    content: this.$t('processInspectionSearch.t59'), // 每次仅可维护一种物料编码的检验报告，请修正！
                                });
                                return false;
                            }
                            this.$router.push({
                                name: 'processInspectionEdit',
                                params: {
                                    selection,
                                    orgId: this.orgList.find((item) => item.organizationCode === orgCode).qmsId,
                                    orgCode,
                                    itemUnit: selection[0].itemUnit,
                                },
                            });
                            // if (!this.$refs.pageForm.$children[0].$children[0].validateForm()) {
                            //     return false;
                            // }
                            // this.$set(button, 'loading', true);
                            // this.exportExcel('/gscint/inspectionReport/exportHeader', {
                            //     ...this.getFormDataVModel(this.formData.items),
                            //     vendorCode: this.vendorCode,
                            // });
                            // setTimeout(() => {
                            //     this.$set(button, 'loading', false);
                            // }, 5000);
                        },
                    },
                    {
                        label: this.$t('processInspectionSearch.t17'), // 导出
                        type: 'primary',
                        icon: 'archive',
                        loading: false,
                        disabled: false,
                        size: 'small',
                        click: (button) => {
                            if (!this.$refs.pageForm.$children[0].$children[0].validateForm()) {
                                return false;
                            }
                            this.$set(button, 'loading', true);
                            this.exportExcel('/gscint/inspectionReport/exportPo', {
                                ...this.getFormDataVModel(this.formData.items),
                                vendorCode: this.vendorCode,
                                language: this.$i18n.locale,
                            });
                            setTimeout(() => {
                                this.$set(button, 'loading', false);
                            }, 5000);
                        },
                    },
                ],
            },
            loading: false,
            settings: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 20, 50, 100],
                needSearch: true,
                needValidation: true,
                currentPage: 1,
                pageSize: 10,
                total: null,
            },
            orgList: [],
            selection: [],
        };
    },
    methods: {
        onSubmit() {
            this.fromToValCheck();
            const formData = this.getFormDataVModel(this.formData.items);
            const { needByDateBegin, needByDateEnd, poNumber, itemCode } = formData;
            // if (needByDateBegin && needByDateEnd) {
            //     if (moment(needByDateBegin).add(1, 'y').format('x') < moment(needByDateEnd).format('x') - 86400000) {
            //         // 检验报告需求日期最大查询范围为1年，请修改！
            //         this.$Modal.warning({
            //             content: this.$t('processInspectionSearch.t119'),
            //         });
            //         return;
            //     }
            // }
            if (poNumber && poNumber.split(',').length > 10) {
                this.$Modal.warning({
                    content: `${this.$t('processInspectionSearch.t118')}${this.$t('processInspectionSearch.t2')}`,
                });
                return;
            }
            if (itemCode && itemCode.split(',').length > 10) {
                this.$Modal.warning({
                    content: `${this.$t('processInspectionSearch.t118')}${this.$t('processInspectionSearch.t4')}`,
                });
                return;
            }
            this.loading = true;
            const { currentPage, pageSize } = this.settings;
            axios.post('/gscint/inspectionReport/queryPoPage', {
                vendorCode: this.vendorCode,
                language: this.$i18n.locale,
                pageNum: currentPage,
                pageSize,
                ...this.getFormDataVModel(this.formData.items),
            })
                .then((res) => {
                    this.loading = false;
                    const { datas, code, msg } = res.data.data;
                    if (code === '1') {
                        this.selection = [];
                        this.tableData = datas.list.map((item) => {
                            const num = item.poQuantity - item.hasCheckedQuantity;
                            return {
                                ...item,
                                checkQuantity: num,
                                checkQuantityCopy: num,
                            };
                        });
                        this.settings.total = datas.total;
                    } else {
                        this.showErrorTips('loading', msg);
                    }
                })
                .catch(() => {
                    this.showErrorTips();
                });
        },
        onSelection(selection) {
            this.selection = selection;
        },
        onPageSizeChange(currentPage, pageSize) {
            this.settings.pageSize = pageSize;
            this.onSubmit();
        },
        onPageChange(currentPage) {
            this.settings.currentPage = currentPage;
            this.onSubmit();
        },
    },
    mounted() {
    },
    activated() {
        const { orgCode } = this.$route.params;
        if (orgCode) {
            this.getFormDataItemObj(this.formData.items, 'orgCode').value = orgCode;
        }
        this.autoSearch();
    },
};
</script>
